/**
 * Handle dynamic clearing of error messages when user starts typing.
 */
function initDynamicValidation() {
    const inputs = document.querySelectorAll('#sb_jobs_outer_form input');

    inputs.forEach(input => {
        input.addEventListener('input', function () {
            this.removeAttribute('aria-invalid');

            const errorId = this.getAttribute('aria-describedby');
            if (errorId) {
                const errorBox = document.getElementById(errorId);
                if (errorBox) {
                    errorBox.textContent = '';
                    errorBox.classList.remove('in');
                }
            }
        });
    });
}

/**
 * Show errors returned from backend and move focus to first invalid field.
 */
function showJobFormErrors(errors) {
    let firstInvalidField = null;

    errors.forEach(err => {
        const errorBox = document.getElementById('error-' + err.path);
        const field = document.querySelector('[name="job[' + err.path + ']"]');

        if (errorBox) {
            errorBox.textContent = err.error;
            errorBox.classList.add('in');
        }
        if (field) {
            field.setAttribute('aria-invalid', 'true');

            if (!firstInvalidField) {
                firstInvalidField = field;
            }
        }
    });

    if (firstInvalidField) {
        firstInvalidField.focus();
    }
}

function uploadClientFile() {
    const uploadField = $('.additional-cv');
    if (!uploadField.length) return;

    const inputFile = $('.upload-cv-input');
    const btn = $('.input-upload-block');
    const fileNameTxt = $('.file-name');
    const defTxt = fileNameTxt.data('default');

    fileNameTxt.html(defTxt);

    btn.on('click', function () {
        $(this).find('.upload-cv-input').click();
    });

    inputFile.on('change', function () {
        $(this).next('.file-name').html($(this).val());
    });
}

function acceptJobPolicy() {
    const checkbox = $('.policy_agreement');
    const submitBtn = $('.vacancies-sections .btn-bar .button-wrap .btn');

    checkbox.on('change', function () {
        if ($(this).is(':checked')) {
            submitBtn.removeAttr('disabled');
        } else {
            submitBtn.attr('disabled', true);
        }
    });
}

/**
 * AJAX submit adaptation (if used).
 * Otherwise this function is used only to show modal.
 */
function showJobModal() {
    if ($('#is-show-success-modal').val()) {
        $('#form-modal-success').modal('show');
    }
}

// Init all features
uploadClientFile();
showJobModal();
acceptJobPolicy();
initDynamicValidation();
